/* Component Dependencies */
var recentlyViewedHotelsTemplate = require('templates/recentlyViewedHotels.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');

AriesComponent.create({
  type: 'recentlyViewedHotels',
  template: {
    'recentlyViewedHotels': recentlyViewedHotelsTemplate 
  },
  bindEvents: function() {
    var _self = this;
    //Read the recently viewed hotels information from local storage.
    this.fetchRecentlyViewedHotelsInfo();
  },

  /**
   * This function is used to read the recently viewed hotels information from local storage
   * 
   */
  fetchRecentlyViewedHotelsInfo: function () {
    var recentlyViewed = "",
    recentViewedList = "",
    renderHotelList = "",
    hotelLists = "",
    recentlyViewedConfig = "",
    showHeading = "",
    checkInDate = "",
    checkOutDate = "",
    todayDate = "",
    tomorrowDate = "",
    shortTodayDate = "",
    shortTomorrowDate ="",
    parseTodayDate = "",
    parseTomorrowDate = "",
    recentlyViewedLabel = this.$el.data('recentlyViewedLabel'),
    recentlyViewedHotelsLabel = this.$el.data('recentlyViewedHotelsLabel'),
    availabilitySearchUrl = this.$el.data('availabilitySearchUrl'),
    checkRatesLabel = this.$el.data('checkRatesLabel'),
    $recentlyViewedContainer = this.$el;
    todayDate = new Date();
    tomorrowDate = new Date(todayDate.getTime() + (24 * 60 * 60 * 1000));
    parseTodayDate = new Date(Date.parse(todayDate));
    parseTomorrowDate = new Date(Date.parse(tomorrowDate));
    shortTodayDate =  (parseTodayDate.getMonth() + 1) + '/' + parseTodayDate.getDate() + '/' +  parseTodayDate.getFullYear();
    shortTomorrowDate =  (parseTomorrowDate.getMonth() + 1) + '/' + parseTomorrowDate.getDate() + '/' +  parseTomorrowDate.getFullYear();
    checkInDate = (typeof dataLayer.chckInDat != "undefined")? dataLayer.chckInDat: shortTodayDate;
    checkOutDate = (typeof dataLayer.chckOutDate != "undefined")? dataLayer.chckOutDate: shortTomorrowDate;
    // Check whether properties are in local storage or not
    recentlyViewed = JSON.parse(window.localStorage.getItem("miRecentlyViewedProperties"));

    if(recentlyViewed && recentlyViewed.recentlyViewedProperties) {
      recentViewedList = recentlyViewed.recentlyViewedProperties;
      recentlyViewedConfig = recentlyViewed.config; 
    if(recentViewedList && recentViewedList.length) {
      
      recentViewedList.forEach( function (property, index) {
        if( index > 2 ){
          return false;
        }
        if(dataLayer.mrshaCode != property.marshaCode){
          showHeading = true;
          hotelLists +='<li class="l-l-col-4 l-padding-none l-pos-relative l-clear"><div><div class="l-pos-relative l-align-center"><picture class="l-picture-wrapper l-display-block l-max-height"><source srcset="'+property.imageUrl+'?interpolation=progressive-bilinear&downsize=500px:*" media="(min-width: 1025px)"><source srcset="'+property.imageUrl+'?interpolation=progressive-bilinear&downsize=600px:* " media="(min-width: 769px)"><source srcset="'+property.imageUrl+'?interpolation=progressive-bilinear&downsize=600px:* " media="(min-width: 769px)"><source srcset="'+property.imageUrl+'?interpolation=progressive-bilinear&downsize=600px:* " media="(min-width: 769px)"><img src="'+property.imageUrl+'?interpolation=progressive-bilinear&downsize=500px:*" class="l-align-center l-width-max" alt=""></picture><span class="t-font-s l-pos-absolute recently-viewed-ribbon">'+ recentlyViewedLabel +'</span></div><div class="l-margin-left l-margin-right"><h3 class="t-font-weight-semibold">'+property.name+'</h3><span class="t-font-m l-display-inline-block">'+property.address+'</span></div></div><div class="l-pos-absolute l-checkRates-container l-width-max"><hr class="m-divider l-one-pixel-line-small"><div class="l-checkRates-button l-margin-left l-margin-right l-margin-bottom"><a href= "'+availabilitySearchUrl+''+property.marshaCode+'&fromDate='+checkInDate+'&toDate='+checkOutDate+'" class="mi-popover m-button m-button-primary t-font-m l-padding l-padding-top-three-quarters l-padding-bottom-three-quarters l-display-inline-block">'+checkRatesLabel+'</a></div></div></li>';
        }
      });
      if(showHeading){
        renderHotelList +='<h2 class="l-center-align t-font-weight-bold t-font-size-heading">' + recentlyViewedHotelsLabel + '</h2>';
        renderHotelList +='<div class="mi-slider l-margin-top-double"><div class="l-frame"><ul class="l-clear l-display-flex">';
        renderHotelList += hotelLists;
        renderHotelList +='</ul></div></div>';
      }
      $recentlyViewedContainer.html(renderHotelList);
     }
    }
  }

});